import React from 'react'
import styled from '@emotion/styled'

//imports the svg as react components rather than loading svg files
import { ReactComponent as phone } from './phone.svg'
import { ReactComponent as print } from './icon-print.svg'
import { ReactComponent as selected } from './icon-selected.svg'
import { ReactComponent as remservWhiteLogo } from './remserv_logo_white.svg'
import { ReactComponent as remservMainLogo } from './remserv_main_logo.svg'
import { ReactComponent as remservLeasingWhiteLogo } from './remserv_leasing_logo_white.svg'
import { ReactComponent as remservLeaseLogo } from './remserv_lease_logo.svg'
import { ReactComponent as Fuel } from './fuel.svg'
import { ReactComponent as ScheduledMaintenance } from './scheduled-maintenance.svg'
import { ReactComponent as ReplacementTyres } from './replacement-tyres.svg'
import { ReactComponent as Incidentals } from './incidentals.svg'
import { ReactComponent as RoadsideAssistance } from './roadside-assistance.svg'
import { ReactComponent as ComprehensiveInsurance } from './ComprehensiveInsurance.svg'
import { ReactComponent as Registration } from './Icon-tick-3.svg'
import { ReactComponent as scroll } from './scroll.svg'
import { ReactComponent as IconTick } from './Icon-tick-3.svg'
import { ReactComponent as RemservTick } from './remserv-tick.svg'
import { ReactComponent as RemservCross } from './cross-icon.svg'
import { ReactComponent as IconDollar } from './Icon-moneybank-Icon-savings.svg'
import { ReactComponent as IconCar } from './Icon-running-costs.svg'
import { ReactComponent as IconPiggy } from './Icon-moneybank.svg'
import { ReactComponent as IconMobile } from './Icon-phone.svg'
import { ReactComponent as IconDollar3 } from './Icon-dollar.svg'
import { ReactComponent as IconCar2 } from './Icon-car.svg'
import { ReactComponent as IconFacebook } from './icon-facebook.svg'
import { ReactComponent as IconInstagram } from './icon-instagram.svg'
import { ReactComponent as IconYoutube } from './icon-youtube.svg'
import { ReactComponent as IconLinkedin } from './icon-linkedin.svg'
import { ReactComponent as RemservLease } from './remserv-lease-logo.svg'
import { ReactComponent as BackArrow } from './back-arrow.svg'
import { ReactComponent as Sheet } from './sheet.svg'
import { ReactComponent as Flame } from './flames.svg'
import { ReactComponent as Electricity } from './Icon-electric.svg'
import { ReactComponent as MoneyBag } from './icon-moneybag.svg'
import { ReactComponent as Savings } from './icon-savings.svg'
import { ReactComponent as Woman } from './Icon-woman.svg'
import { ReactComponent as Search } from './icon-search.svg'
import { ReactComponent as DropDown } from './icon-drpdwn.svg'
import { ReactComponent as WaitingDots } from './waiting_dots.svg'
import { ReactComponent as AllDone } from './all-done-tick.svg'
import { ReactComponent as AdobeSign } from './adobe_sign.svg'
import { ReactComponent as BluePencil } from './blue_pencil.svg'
import { ReactComponent as ArrowLeft } from './icon-left-arrow.svg'
import { ReactComponent as ArrowRight } from './icon-right-arrow.svg'
import { ReactComponent as AccordionMinus } from './remserv-minus.svg'
import { ReactComponent as AccordionPlus } from './remserv-plus.svg'
import { ReactComponent as LeaseRelease } from './lease-release-icon.svg'
import { ReactComponent as LeaseUpgrade } from './lease-upgrade-icon.svg'
import { ReactComponent as LeasePayout } from './lease-pay-icon.svg'
import { ReactComponent as TrashCan } from './trash.svg'
import { ReactComponent as Paperclip } from './paperclip-vertical-solid.svg'
import { ReactComponent as Upload } from './upload.svg'




const iconsMap = {
  AccordionMinus,
  AccordionPlus,
  AdobeSign,
  AllDone,
  ArrowLeft,
  ArrowRight,
  BackArrow,
  BluePencil,
  ComprehensiveInsurance,
  DropDown,
  Electricity,
  Flame,
  Fuel,
  IconCar,
  IconCar2,
  IconDollar,
  IconDollar3,
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconMobile,
  IconPiggy,
  IconTick,
  IconYoutube,
  Incidentals,
  LeasePayout,
  LeaseRelease,
  LeaseUpgrade,
  MoneyBag,
  Paperclip,
  phone,
  print,
  Registration,
  RemservCross,
  RemservLease,
  remservLeaseLogo,
  remservLeasingWhiteLogo,
  remservMainLogo,
  RemservTick,
  remservWhiteLogo,
  ReplacementTyres,
  RoadsideAssistance,
  Savings,
  ScheduledMaintenance,
  scroll,
  Search,
  selected,
  Sheet,
  TrashCan,
  Upload,
  WaitingDots,
  Woman,
}

export const Icon = (props) => {
  const iconType = props.iconType
  const size = props.size
  const primary = props.primary
  const CustomIcon = styled(iconsMap[iconType] || phone)`
    label: CustomIcon;
    height: ${size ? size * 24 + 'px' : 'auto'};
    fill: ${(props) => primary && props.theme.colors.primary};
  `

  return <CustomIcon />
}
